<div class="page">
  <div class="header">
    <button mat-icon-button class="btn-atras" type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Barrios de {{ municipio.nombre }}</h1>
      <p>Agrega los barrios o colonias que se podrán elegir al registrar un paciente.</p>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="barrio-form" (ngSubmit)="guardar()">
      <mat-form-field appearance="outline">
        <mat-label>Nombre del barrio</mat-label>
        <input matInput formControlName="nombre" placeholder="Ej. El naranjo" />

        @if (form.get('nombre')?.hasError('required')) {
          <mat-error>El nombre es obligatorio.</mat-error>
        }
        @if (form.get('nombre')?.hasError('duplicado')) {
          <mat-error>Ese barrio ya existe en este municipio.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="campo-acronimo">
        <mat-label>Acrónimo</mat-label>
        <input matInput formControlName="acronimo" maxlength="10" placeholder="Ej. NR" />

        @if (form.get('acronimo')?.hasError('required')) {
          <mat-error>El acrónimo es obligatorio.</mat-error>
        }
      </mat-form-field>

      <button mat-flat-button class="add-boton" type="submit" [disabled]="guardando">
        {{ barrioEnEdicion ? 'Guardar cambios' : 'Agregar' }}
        <mat-icon>{{ barrioEnEdicion ? 'save' : 'add' }}</mat-icon>
      </button>

      @if (barrioEnEdicion) {
        <button mat-button type="button" (click)="cancelarEdicion()">Cancelar</button>
      }
    </form>

    <h2>Barrios agregados ({{ barrios.length }})</h2>

    @if (cargando) {
      <p class="sin-datos">Cargando barrios...</p>
    } @else if (barrios.length === 0) {
      <p class="sin-datos">Este municipio todavía no tiene barrios.</p>
    }

    @for (barrio of barrios; track barrio.id) {
      <div class="barrio-item">
        <span>{{ $index + 1 }}. {{ barrio.nombre }} ({{ barrio.acronimo }})</span>
        <div>
          <button
            mat-icon-button
            type="button"
            class="edit-btn"
            matTooltip="Editar barrio"
            (click)="editar(barrio)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            class="delete-btn"
            type="button"
            matTooltip="Eliminar barrio"
            (click)="eliminar(barrio)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </mat-dialog-content>
</div>
